var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 28 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 0h24.3c1 0 1.9.9 1.9 2s-.8 2-1.9 2H1.9C.8 4 0 3.1 0 2s.8-2 1.9-2M1.9 9h24.3c1 0 1.9.9 1.9 2s-.8 2-1.9 2H1.9c-1 0-1.9-.9-1.9-2s.8-2 1.9-2M1.9 18h24.3c1 0 1.9.9 1.9 2s-.8 2-1.9 2H1.9c-1 0-1.9-.9-1.9-2s.8-2 1.9-2"
  })));
};
export default SvgHamburger;